export function LilDragonsKickingTabContent() {
  return (
    <div className="mt-10">
      <h3 className="text-lg font-semibold text-taekwondo-red mb-4">Kicking</h3>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div className="bg-white rounded-lg p-4 shadow-sm flex items-center gap-4">
          <img
            src="/images/dragons/dragon_front.png"
            alt="Lil' Dragon front kick"
            className="h-24 w-auto flex-shrink-0"
            loading="lazy"
            decoding="async"
          />
          <div className="text-left">
            <h4 className="text-md font-semibold mb-1">Front Kick</h4>
            <p className="text-sm text-gray-700">
              Toes back and kick with the ball of your foot!
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-sm flex items-center gap-4">
          <img
            src="/images/dragons/dragon_side.png"
            alt="Lil' Dragon side kick"
            className="h-24 w-auto flex-shrink-0"
            loading="lazy"
            decoding="async"
          />
          <div className="text-left">
            <h4 className="text-md font-semibold mb-1">Side Kick</h4>
            <p className="text-sm text-gray-700">
              Kick with the blade of your foot. Don&apos;t forget to chamber!
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-sm flex items-center gap-4">
          <img
            src="/images/dragons/dragon_round.png"
            alt="Lil' Dragon round kick"
            className="h-24 w-auto flex-shrink-0"
            loading="lazy"
            decoding="async"
          />
          <div className="text-left">
            <h4 className="text-md font-semibold mb-1">Round Kick</h4>
            <p className="text-sm text-gray-700">
              Kick with your laces and a big swing of your leg!
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-4 shadow-sm flex items-center gap-4">
          <img
            src="/images/dragons/dragon_axe.png"
            alt="Lil' Dragon axe kick"
            className="h-24 w-auto flex-shrink-0"
            loading="lazy"
            decoding="async"
          />
          <div className="text-left">
            <h4 className="text-md font-semibold mb-1">Axe Kick</h4>
            <p className="text-sm text-gray-700">
              Reach your leg for the sky and stomp down with your heel!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
